import { render } from "./ReliefOldList.vue?vue&type=template&id=5b3b4ed0&scoped=true"
import script from "./ReliefOldList.vue?vue&type=script&lang=js"
export * from "./ReliefOldList.vue?vue&type=script&lang=js"

import "./ReliefOldList.vue?vue&type=style&index=0&id=5b3b4ed0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3b4ed0"]])

export default __exports__